// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_LICENSE_EXIST = 'solusio-license/SET_LICENSE_EXIST';
export const SET_LICENSE_ITEM = 'solusio-license/SET_LICENSE_ITEM';
